<template>
  <div class="api-card" @click="$emit('click')">
    <div class="api-card-header">
      <h3 class="api-card-title">{{ api.name }}</h3>
      <span class="status-badge" :class="statusClass">
        {{ api.status }}
      </span>
    </div>
    
    <p class="api-card-description">{{ api.description }}</p>
    
    <div class="api-card-meta">
      <span class="api-card-version">v{{ api.version }}</span>
      <span class="api-card-date">{{ formatDate(api.updatedAt) }}</span>
    </div>
    
    <div class="api-card-actions">
      <!-- <button @click.stop="generateCode" class="api-card-action-btn">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
        </svg>
        Gerar Código
      </button> -->
      <!-- <button @click.stop="viewDocs" class="api-card-action-btn primary">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
        </svg>
        Ver Docs
      </button> -->
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  api: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['generate-code', 'view-docs', 'click'])

const statusClass = computed(() => {
  switch (props.api.status?.toLowerCase()) {
    case 'active':
      return 'status-active'
    case 'deprecated':
      return 'status-deprecated'
    case 'inactive':
      return 'status-inactive'
    default:
      return ''
  }
})

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

const generateCode = () => {
  emit('generate-code', props.api)
}

const viewDocs = () => {
  emit('view-docs', props.api)
}
</script>